<template>
  <vs-row>
    <vs-col>
      <div class="dashboard-layout">
        <home-notification-card style="grid-column: 1 / 3;" title="국립공원공단 안전·보건 경영 시스템 " :disabled="false"/>
        <community-healthinfo-card style="grid-column: 3 / 5;"/>
        <community-business-news-card style="grid-column: 1 / 3;"/>
        <community-work-news-card style="grid-column: 3 / 5;"/>
        <donut-chart-card title="안전·보건 예산 현황" :value="data1" :total="data1Total" unit="천원" :isMoveWrite="isMoveWrite"
                          @detail="onClickDetail(1)" @write="onClickWrite(1)"/>
        <donut-chart-card title="산업재해발생 현황" :value="data2" :total="data2Total" unit="건" :isMoveWrite="isMoveWrite"
                          @detail="onClickDetail(2)" @write="onClickWrite(2)"/>
        <donut-chart-card title="안전·보건 교육 현황" :value="data3" :total="data3Total" unit="건" :isMoveWrite="isMoveWrite"
                          @detail="onClickDetail(3)" @write="onClickWrite(3)"/>
        <donut-chart-card title="파트너사 계약 현황" :value="data8" :total="data8Total" unit="건" :isMoveWrite="false"
                          @detail="onClickDetail(8)" @write="onClickWrite(8)"/>
        <donut-chart-card title="위험성평가 현황" :value="data4" :total="data4Total" unit="건" :isMoveWrite="isMoveWrite"
                          @detail="onClickDetail(4)" @write="onClickWrite(4)"/>
        <donut-chart-card title="작업허가서 현황" :value="data5" :total="data5Total" unit="건" :isMoveWrite="isMoveWrite"
                          @detail="onClickDetail(5)" @write="onClickWrite(5)"/>
        <donut-chart-card title="안전점검 현황" :value="data6" :total="data6Total" unit="건" :isMoveWrite="isMoveWrite"
                          @detail="onClickDetail(6)" @write="onClickWrite(6)"/>
        <donut-chart-card title="시정 및 예방조치 현황" :value="data7" :total="data7Total" unit="건" :isMoveWrite="isMoveWrite"
                          @detail="onClickDetail(7)" @write="onClickWrite(7)"/>

      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import DonutChartCard from '@/views/components/DonutChartCard'
import HomeNotificationCard from '@/views/components/HomeNotificationCard'
import CommunityHealthinfoCard from '@/views/components/CommunityHealthinfoCard'
import CommunityWorkNewsCard from '@/views/components/CommunityWorkNewsCard'
import CommunityBusinessNewsCard from '@/views/components/CommunityBusinessNewsCard'

export default {
  components: {
    CommunityBusinessNewsCard,
    CommunityWorkNewsCard,
    CommunityHealthinfoCard,
    HomeNotificationCard,
    DonutChartCard
  },
  data () {
    return {
      isMoveWrite: false,

      dateTarget: 'created_at',
      dateBegin: `${new Date().getFullYear()}-01-01`,
      dateEnd: `${new Date().getFullYear()}-12-31`,

      data1Total: 0,
      data2Total: 0,
      data3Total: 0,
      data4Total: 0,
      data5Total: 0,
      data6Total: 0,
      data7Total: 0,
      data8Total: 0,

      // 안전·보건 예산 현황
      data1: [
        {
          label: 'label',
          value: 0
        }
      ],

      // 산업재해발생 현황
      data2: [
        {
          label: 'label',
          value: 0
        }
      ],

      // 안전·보건 교육 현황
      data3: [
        {
          label: 'label',
          value: 0
        }
      ],

      // 위험성평가 현황
      data4: [
        {
          label: 'label',
          value: 0
        }
      ],

      // 작업허가서 현황
      data5: [
        {
          label: 'label',
          value: 0
        }
      ],

      // 안전점검 현황
      data6: [
        {
          label: 'label',
          value: 0
        }
      ],

      // 시정 및 예방조치 현황
      data7: [
        {
          label: 'label',
          value: 0
        }
      ],

      // 파트너사 계약 현황
      data8: [
        {
          label: 'label',
          value: 0
        }
      ]
    }
  },
  async created () {

  },
  mounted () {

    // 안전·보건 예산 현황
    this.loadGraph1()

    // 산업재해발생 현황
    this.loadGraph2()

    // 안전·보건 교육 현황
    this.loadGraph3()

    // 파트너사 계약 현황
    this.loadPartnerContractStatusListAll()

    // 위험성평가 현황
    this.loadGraph4()

    // 작업허가서 현황
    this.loadGraph5()

    // 안전점검 현황
    this.loadGraph6()

    // 시정 및 예방조치 현황
    this.loadGraph7()

  },
  methods: {

    getContent (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content
      }
    },

    convertSummaryMonthlyToGraphData (summary) {

      const list = {}

      for (const type of ['sum', 'count']) {
        if (!list[type]) list[type] = []

        const child = summary[type].child
        const keys = Object.keys(child)
        for (const key of keys) {
          list[type].push({label: key, value: child[key].total})
        }
      }

      return list
    },
    async loadGraph (boardId, type, onlyTopList) {
      const data = []
      let total = 0
      try {
        await this.$store.dispatch('summary/LOAD_SUMMARY_GROUP_MONTHLY', {
          boardId,
          year: new Date().getFullYear()
        })
        const summary = this.$store.state.summary.summaryMonthly
        const summaryConvertSum = this.convertSummaryMonthlyToGraphData(summary)[type]
        total = summary[type].total ? summary[type].total : 0

        summaryConvertSum.sort(function (a, b) {
          if (a.value > b.value) return -1
          else if (a.value < b.value) return 1
          else return 0
        })

        const max = onlyTopList ? 4 : summaryConvertSum.length
        for (let i = 0; i < Math.min(summaryConvertSum.length, max); i++) {
          data.push(summaryConvertSum[i])
        }
        // eslint-disable-next-line no-empty
      } catch (err) {}

      return {
        data,
        total
      }
    },
    combineGraphData (data1, data2, onlyTopList) {
      const obj = {}
      const data = []

      for (const data of data1.data) {
        if (!obj[data.label]) obj[data.label] = 0
        obj[data.label] += data.value
      }
      for (const data of data2.data) {
        if (!obj[data.label]) obj[data.label] = 0
        obj[data.label] += data.value
      }

      const keys = Object.keys(obj)
      for (const key of keys) {
        data.push({ label: key, value: obj[key]})
      }

      data.sort(function (a, b) {
        if (a.value > b.value) return -1
        else if (a.value < b.value) return 1
        else return 0
      })

      const max = onlyTopList ? 4 : data.length
      data.splice(max, data.length - max)

      return {
        data, //data: data.length > 0 ? data : [{label:'label', value: 0}],
        total: data1.total + data2.total
      }
    },

    async loadGraph1 () {
      const graph = await this.loadGraph(3, 'sum', true)
      this.data1 = graph.data.map(data => {
        return {
          label: data.label,
          value: Math.floor(data.value / 1000.0)
        }
      })
      this.data1Total = Math.floor(graph.total / 1000.0)
    },

    async loadGraph2 () {
      const graph = await this.loadGraph(45, 'count', true)
      this.data2 = graph.data
      this.data2Total = graph.total
    },

    async loadGraph3 () {
      const graph = await this.loadGraph(35, 'count', true)
      this.data3 = graph.data
      this.data3Total = graph.total
    },

    async loadPartnerContractStatusListAll () {
      const boardId = 50
      const page = 1
      const perPage = 10000
      await this.$store.dispatch('board/LOAD_POST_LIST', {
        boardId,
        page,
        perPage
      })

      const listAll = [...JSON.parse(JSON.stringify(this.$store.state.board.postListInfo.data))]
      const value = [
        { label:'50억 이상', count: 0},
        { label:'10억 이상 ~ 50억 미만', count: 0},
        { label:'5억 이상 ~ 10억 미만 ', count: 0},
        { label:'5억 미만', count: 0}
      ]
      if (listAll.length > 0) {
        listAll.map(data => {
          const content = this.getContent(data)
          const _100_million = Math.floor(content.agreementInfo.amount / 100000000)

          if (_100_million >= 50)       value[0].count++
          else if (_100_million >= 10)  value[1].count++
          else if (_100_million >= 5)   value[2].count++
          else                          value[3].count++
        })
      }

      // 리스트로 만들기
      let total = 0
      const list = []
      value.map(item => {
        list.push({
          label: item.label,
          value: item.count
        })

        total = total + item.count
      })

      // list.sort(function (a, b) {
      //   if (a.value > b.value) return -1
      //   else if (a.value < b.value) return 1
      //   else return 0
      // })

      const data = []
      for (let i = 0; i < Math.min(list.length, 4); i++) {
        data.push(list[i])
      }
      this.data8 = data
      this.data8Total = total
    },
    async loadGraph4 () {
      const graph7 = await this.loadGraph(7, 'count', false)
      const graph41 = await this.loadGraph(41, 'count', false)
      const graphData = this.combineGraphData(graph7, graph41, true)
      this.data4 = graphData.data
      this.data4Total = graphData.total
    },

    async loadGraph5 () {
      const graph10 = await this.loadGraph(10, 'count', false)
      const graph11 = await this.loadGraph(11, 'count', false)
      const graphData = this.combineGraphData(graph10, graph11, true)
      this.data5 = graphData.data
      this.data5Total = graphData.total
    },

    async loadGraph6 () {
      const graph = await this.loadGraph(48, 'count', true)
      this.data6 = graph.data
      this.data6Total = graph.total
    },

    async loadGraph7 () {
      const graph36 = await this.loadGraph(36, 'count', false)
      const graph40 = await this.loadGraph(40, 'count', false)
      const graphData = this.combineGraphData(graph36, graph40, true)
      this.data7 = graphData.data
      this.data7Total = graphData.total
    },

    getPostPreview (data) {
      if (data.post.preview) {
        const preview = JSON.parse(data.post.preview)
        return preview
      }
    },

    getNumber (strNum) {
      try {
        return Number(strNum)
      } catch (err) {
        return 0
      }
    },

    onClickDetail (index) {
      switch (index) {
      case 1: this.$router.push('/graph/3'); break
      case 2: this.$router.push('/graph/45'); break
      case 3: this.$router.push('/graph/35'); break
      case 4: this.$router.push('/graph/7'); break
      case 5: this.$router.push('/graph/10'); break
      case 6: this.$router.push('/graph/48'); break
      case 7: this.$router.push('/graph/36'); break
      case 8: this.$router.push('/graph/50'); break
      }
    },
    onClickWrite (index) {

    }

  }
}
</script>

<style scoped>
.dashboard-layout {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 16px;

}
</style>
